var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8833 14.991L5.84361 14.4926C5.78669 14.4971 5.76883 14.4985 5.75488 14.4992C5.74413 14.4998 5.73562 14.4999 5.69675 14.5003C5.33205 14.4997 4.98243 14.3545 4.72773 14.0985L4.72679 14.0975L1.40415 10.7749L1.40369 10.7744C0.865677 10.2378 0.865455 9.36668 1.40291 8.82922C1.93962 8.29252 2.81065 8.29252 3.34735 8.82922L5.09594 10.5778L5.51604 10.9979L5.85823 10.5122L12.4997 1.08571L12.5003 1.08483C12.9369 0.462304 13.796 0.313254 14.4175 0.751744L14.4176 0.751776C15.0379 1.18933 15.1867 2.04714 14.7496 2.66707L14.7495 2.66723L6.8244 13.9157L6.824 13.9163C6.58714 14.2535 6.21525 14.4625 5.84293 14.4927L5.8833 14.991ZM5.8833 14.991C6.40855 14.9485 6.91361 14.6586 7.23314 14.2037L4.37324 14.4511C4.72314 14.8029 5.20162 15.0003 5.69901 15.0003C5.77632 14.9996 5.77633 14.9996 5.88325 14.991L5.8833 14.991Z",
    fill: "#414C5A",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCheck);
export default __webpack_public_path__ + "static/media/grey-check.9157678fa24a8863f37c078b30b3f472.svg";
export { ForwardRef as ReactComponent };